module.exports = __webpack_public_path__ + "4a997518c98c5562c92bb199f8b059ca.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/orange@2x.png
// module id = 308
// module chunks = 0